.registerFlowContainer {
  overflow-y: auto;
  overflow-x: hidden;
  margin: 10px;
  padding: 10px;
}
